<section class="carousel-wrapper">
    <ul class="carousel" #carousel>
       <!--  We need to loop over the items -->
       <li></li>
    </ul>
  </section>